import { render } from "./SelectionType.vue?vue&type=template&id=c8d397f6&scoped=true"
import script from "./SelectionType.vue?vue&type=script&lang=ts"
export * from "./SelectionType.vue?vue&type=script&lang=ts"

import "./SelectionType.vue?vue&type=style&index=0&id=c8d397f6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c8d397f6"

export default script